export default {
  timePlaceholder: 'чч:мм',
};
